<template>
  <report-page
    :title="name"
    :data-to-send="dataToSend"
    :buttons-disabled="buttonsDisabled"
    :history-filter="historyFilter"
    :selectedWorkspaceUUID="selectedWorkspace"
  >
    <template v-slot:reportForm>
      <report-field :field-name="$tc('Workspace', 1)">
        <treeselect
          v-model="selectedWorkspace"
          @select="selectedWorkspaceGeom = $event.geom"
          :options="workspaceOptions"
          :disabled="
            !hasPermissionToCreateExport ||
            workspaceSelectionDisabled ||
            !userHasManagementPermission('workspace', 'list')
          "
          disableFuzzyMatching
        />
      </report-field>
      <report-field :field-name="$t(reportParameters[0].label)">
        <treeselect
          v-model="reportParameters[0].value"
          @input="resetClosureOptions"
          :options="networkStartingPointOptions"
          :load-options="getNetworkStartingPointOptions"
          :disabled="
            !hasPermissionToCreateExport ||
            technicalSiteLocalDisabled ||
            !userHasPermissionToList('technical_local')
          "
          :disable-branch-nodes="true"
          disableFuzzyMatching
        />
      </report-field>

      <report-field :field-name="$tc(reportParameters[1].label, 1)">
        <treeselect
          v-model="reportParameters[1].value"
          :options="closureOptions"
          :load-options="loadClosureOptions"
          :disabled="
            !hasPermissionToCreateExport ||
            technicalSiteLocalDisabled ||
            !userHasPermissionToList('closure')
          "
          :normalizer="normalizer"
          :disable-branch-nodes="true"
          disableFuzzyMatching
        />
      </report-field>
    </template>
  </report-page>
</template>

<script>
import ReportPage from "../ReportPage";
import ReportField from "../ReportField";
import { homeReportPageMixin } from "@/mixins/homeReportPageMixin";
import { mapActions } from "vuex";

export default {
  name: "NetworkStartingPointReport",

  components: {
    ReportField,
    ReportPage,
  },

  mixins: [homeReportPageMixin],

  props: {
    name: {
      type: String,
      required: true,
    },
    version: {
      type: String,
    },
  },

  data() {
    return {
      selectedWorkspaceGeom: null,
      reportParameters: [
        {
          label: "NetworkStartingPoint",
          key: "technical_local",
          type: "text",
          value: undefined,
        },
        {
          label: "Closure",
          key: "closure",
          type: "text",
          value: undefined,
        },
      ],

      historyFilter: "excel",
    };
  },

  computed: {
    /**
     * Determines if report buttons are disabled
     * @returns {boolean}
     */
    buttonsDisabled() {
      return (
        (this.reportParameters[0].value === undefined &&
          this.reportParameters[1].value === undefined) ||
        this.selectedWorkspace === undefined
      );
    },

    technicalSiteLocalDisabled() {
      return this.selectedWorkspace === undefined;
    },
    /**
     * Prepares the data to send the server to generate report
     * @returns {{objects: {workspace_uuid, object: {object_type, uuid}}, type: string, version: String}}
     */
    dataToSend() {
      let data = {
        type: this.historyFilter,
        version: this.version,
        objects: {
          workspace_uuid: this.selectedWorkspace,
          object: {
            uuid: this.reportParameters[0].value,
            object_type: this.reportParameters[0].key,
          },
        },
      };
      if (this.reportParameters[1].value) {
        data.objects.object = {
          uuid: this.reportParameters[1].value,
          object_type: this.reportParameters[1].key,
        };
      }

      return data;
    },
  },

  watch: {
    selectedWorkspace() {
      this.resetReportParameterValues(this.reportParameters, 0);
      this.networkStartingPointOptions = null;
      this.closureOptions = null;
    },
  },

  mounted() {
    this.setWorkspaceField();
  },
  methods: {
    ...mapActions([
      "GET_ALL_OBJECTS_IN_GIVEN_WORKSPACE",
      "GET_TECHNICAL_LOCAL_WITH_LOGICAL_RELATIONS",
    ]),

    /**
     * reset closure options and the field where the value of the selected closure is stored
     */
    resetClosureOptions() {
      this.resetReportParameterValues(this.reportParameters, 1);
      this.closureOptions = null;
    },

    /**
     * Get closing options depending on whether the Network Starting Point field has any objects selected.
     * If so, we get the closures that are associated with the technical local.
     * If not, we get all closures from the workspace
     * @returns {Promise<void>}
     */
    async loadClosureOptions() {
      try {
        if (this.reportParameters[0].value) {
          let technicalLocal =
            await this.GET_TECHNICAL_LOCAL_WITH_LOGICAL_RELATIONS({
              technicalLocalUUID: this.reportParameters[0].value,
              workspaceUUID: this.selectedWorkspace,
              includes: ["logicalrelationsclosures"],
            });
          this.closureOptions = technicalLocal["logicalrelationsclosures"];
        } else {
          this.closureOptions = await this.GET_ALL_OBJECTS_IN_GIVEN_WORKSPACE({
            endpoint: "closures",
            workspaceUUID: this.selectedWorkspace,
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    /**
     * Normalizer for the list of closure options (so that the treeselect component can read it).
     * @param node
     * @returns {{id: *, label: (*|string)}}
     */
    normalizer(node) {
      return {
        id: node.cl_uuid,
        label: node.cl_label ? node.cl_label : "ID:" + node.cl_id,
      };
    },
  },
};
</script>
<style>
#radio-label-spacing .v-input--selection-controls__input {
  margin-right: 0 !important;
}
</style>












};



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Reports/ReportsPages/NSPR.vue